import { useCallback, useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { CustomSelect } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { EntityListProps } from './EntityList.props';

const EntityList = ({ cell, ...restProps }: EntityListProps) => {
  const { value: cellValue, key, readOnly } = cell;
  const { onCommit, onRevert } = restProps;
  const [{ companyInfo }] = useStore() as unknown as UseStoreValues;
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext) as any;
  const [availableEntities, setAvailableEntities] = useState<OptionType[]>([]);

  useEffect(() => {
    if (!companyInfo) {
      return;
    }
    const availableEntities = [
      {
        id: String(companyInfo.id),
        value: String(companyInfo.id),
        label: companyInfo.name ?? '',
      },
      ...(companyInfo?.child_companies || []).map((child: any) => ({
        id: String(child.company_id),
        value: String(child.company_id),
        label: child.company_name ?? '',
      })),
    ];

    setAvailableEntities(availableEntities);
  }, [companyInfo]);

  const handleChange = useCallback(
    (value: string | null) => {
      onCellsChanged([{ cell, value }]);
    },
    [cell, onCellsChanged]
  );

  if (!isEmpty(availableEntities)) {
    return (
      <CustomSelect
        autoFocus
        disabled={readOnly}
        id={`security-list-${key}`}
        menuPosition="bottom"
        onChange={handleChange}
        onCommit={onCommit}
        onEmptyValue="SELECT ENTITY"
        onRevert={onRevert}
        openMenuOnFocus
        options={availableEntities}
        value={cellValue as string}
      />
    );
  }
  return null;
};

export default EntityList;
